module.exports = __webpack_public_path__ + "assets/9e10c871278bf3e37cc171a28f503e8f.png";